import Box from '@mui/material/Box';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import image1 from './image/image-1.webp';
import image2 from './image/image-2.webp';
import image3 from './image/image-3.webp';

import { Autoplay, Navigation, Pagination } from 'swiper';

const Hero = () => {
    return (
        <Box height="80%">
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                pagination={{
                    clickable: true,
                }}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
            >
                <SwiperSlide>
                    <img
                        src={image1}
                        alt={'slide1'}
                        style={{ width: 'inherit' }}
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        src={image2}
                        alt={'slide2'}
                        style={{ width: 'inherit' }}
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        src={image3}
                        alt={'slide3'}
                        style={{ width: 'inherit' }}
                    />
                </SwiperSlide>
            </Swiper>
        </Box>
    );
};

export default Hero;
